import * as React from "react";
import { CheckboxListNewItem } from "./checkbox-list-new-item";
import { CheckboxLisItem } from "./checkbox-list-item";
import { ISize } from "../../interfaces/dropdown-sizes-types";

interface ICheckboxListBodyProps {
    items: ISize[];
    onChange: (item: ISize, createNewItem?: boolean) => void;
    onItemAdded: () => void;
}

export const CheckboxListBody: React.FC<ICheckboxListBodyProps> = ({ items, onChange, onItemAdded }) => {
    const handleCheckboxChange = (item: ISize) => (event: React.ChangeEvent<HTMLInputElement>) => {
        item.selected = event.target.checked;
        onChange(item);
    };
    const itemsThatWereAdded = React.useMemo(() => items.filter((item) => item.wasAdded), [items]);
    const initialItems = React.useMemo(() => items.filter((item) => !item.wasAdded), [items]);

    return (
        <div>
            <div className="sizes">
                {initialItems.map((item) => (
                    <CheckboxLisItem key={item.id} item={item} onCheckboxChange={handleCheckboxChange(item)} />
                ))}
            </div>
            {itemsThatWereAdded.length > 0 && <hr />}
            {itemsThatWereAdded.map((item) => (
                <CheckboxListNewItem
                    key={item.id}
                    item={item}
                    onTextChange={onChange}
                    onCheckboxChange={handleCheckboxChange(item)}
                    onItemAdded={onItemAdded}
                />
            ))}
        </div>
    );
};
